import React from 'react'
import Message from './Message'

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		console.error('boundary error:', error)
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// console.log('catch:', error, errorInfo)
		// You can also log the error to an error reporting service
		// logErrorToMyService(error, errorInfo);
	}

	componentDidMount() {
		// console.log('Error Boundary did mount')
	}

	componentDidUpdate() {
		const { refreshStamp } = this.props
		// console.log('Error Boundary did update:', this.pathname, pathname)
		this.refreshStamp !== refreshStamp && (this.refreshStamp = refreshStamp, this.setState({ hasError: false }))
	}

	render() {
		const { onClose } = this.props

		// console.log('test', this.props)
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <Message text='出错了' onClose={onClose} />
		}

		return this.props.children;
	}
}

export default ErrorBoundary